import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ClientGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      if (!this.authService.isProfileSelected()) {
        this.router.navigate(['login', 'select-profile']);
        return observer.next(false);
      }

      return observer.next(true);
    });
  }
}
